
import { Box, Skeleton, Stack } from '@mantine/core'

const EvidenceLoader = () => {
  return (
    <Box p="md">
      <Stack spacing="md">
        {/* Header skeleton */}
        <Box>
          <Skeleton height={24} width={200} radius="sm" mb={8} />
          <Skeleton height={16} width={150} radius="sm" />
        </Box>

        {/* Content skeletons */}
        {[...Array(3)].map((_, index) => (
          <Box key={index}>
            <Skeleton height={20} width="100%" radius="sm" mb={8} />
            <Skeleton height={16} width="80%" radius="sm" mb={4} />
            <Skeleton height={16} width="60%" radius="sm" />
          </Box>
        ))}
      </Stack>
    </Box>
  )
}

export default EvidenceLoader